// extracted by mini-css-extract-plugin
module.exports = {"brands":"brands_brands__19vro","title":"brands_title__3wJho","container":"brands_container__3hKvn"};